import React, { useEffect, useMemo } from 'react'
import { fetchFreemiumReportData } from '../features/Voyage/VoyageSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Table } from 'antd'
 
const FreemiumTable = ({ columns, searchText }) => {
 
    const dispatch = useDispatch()
    const { freemiumReportData } = useSelector((state) => state.voyage)
 
    const formatDate = (isoDate) => {
        const date = new Date(isoDate)
        const formattedDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        return formattedDate
    }
 
    useEffect(() => {
        dispatch(fetchFreemiumReportData())
    }, [dispatch])

    const formattedData = useMemo(() => {
        if (!Array.isArray(freemiumReportData)) {
            return []
        }
 
        return freemiumReportData.map(item => ({
            ...item,
            date_created: formatDate(item.created_at)
        }))
    }, [freemiumReportData])

    // Filter data based on search text
    const filteredData = useMemo(() => {
        if (!searchText || searchText.trim() === '') {
            return formattedData
        }

        const searchLower = searchText.toLowerCase().trim()

        return formattedData.filter(item => {
            const imoNumber = item.imo_number?.toString().toLowerCase() || ''
            const vesselName = item.vessel_name?.toLowerCase() || ''
            
            return imoNumber.includes(searchLower) || vesselName.includes(searchLower)
        })
    }, [formattedData, searchText])
 
    return (
        <div>
            <Table
                dataSource={filteredData}
                columns={columns}
                rowClassName="editable-row"
                rowKey={(record, index) => record?._local_id || record?.id || record?.created_at || `${record?.imo_number || 'report'}-${index}`}
                scroll={{ y: "40vh" }}
                pagination={false}
                responsive
            />
        </div>
    )
}
 
export default FreemiumTable